<template>
  <van-popup v-model="isVisible" :style="{width:'90vw'}" class="code-pop" overlay-class="code-overlay" closeable>
    <div class="pop-content">
      <div class="code-box">
        <div class="title">邀请门店二维码</div>
        <div class="img-box">
          <qrcode-vue :value="qrUrl" :size="150" render-as="svg"></qrcode-vue>
        </div>
      </div>
      <div class="info-box">
        <div class="activity-title">{{activityData.activityTitle}}</div>
        <k-v-panel label="活动ID">{{activityData.activityId}}</k-v-panel>
        <k-v-panel label="费用">{{activityData.signUpFee ? activityData.signUpFee + '元' : '免费'}}</k-v-panel>
        <k-v-panel label="邀请人">{{activityData.invitee}}</k-v-panel>
        <k-v-panel label="开始时间">{{activityData.startTime | shortDate}}</k-v-panel>
        <k-v-panel label="结束时间">{{activityData.endTime | shortDate}}</k-v-panel>
      </div>
    </div>
  </van-popup>
</template>

<script>
import {QrCodeEnum} from '@/utils/constant'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    invitationData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    activityData() {
      return this.invitationData;
    },
  },
  data() {
    return {
      qrUrl: ''
    }
  },
  methods: {

  },
  created() {
    const qrUrlObj = {
      type: QrCodeEnum.join,
      activityId: this.activityData.activityId
    }
    this.qrUrl = JSON.stringify(qrUrlObj);
  }
}
</script>

<style lang="stylus" scoped>
.code-pop
  border-radius 8px
  .code-box
    border-bottom 1px dotted $mainTextColor
    .title
      padding 20px 0
      font-size 16px
      font-weight bold
      text-align: center
    .img-box
      margin-bottom: 20px
      text-align: center
  .info-box
    padding 0 15px 20px
    .activity-title
      padding 15px 0 10px
      font-size 16px
      color $mainTextColor
    >>> .k-v-panel
      padding 5px 0
</style>
<style lang="stylus">
.code-overlay
  background-color: #f6f6f6
</style>